/**
 * @azoupvendas/client
 *
 * PWA Offline-first para gestão de força de vendas
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './styles/global.css';
import { usePedidoStore } from './modules/pedidos/stores/pedido.store';

// AIDEV-NOTE: Registro explicito do SW — checagem horaria de update p/ sessoes longas
// (o registerSW.js auto-injetado do vite-plugin-pwa deixa de ser gerado com este import)
registerSW({
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return;
    setInterval(
      () => {
        // AIDEV-NOTE: Nao busca update com carrinho em digitacao — troca de SW podia
        // recarregar a pagina no meio do pedido. O persist torna o reload sobrevivivel,
        // mas evitar o reload continua sendo melhor UX.
        if (usePedidoStore.getState().itens.length > 0) return;
        registration.update();
      },
      60 * 60 * 1000
    );
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
